import { render, staticRenderFns } from "./VerifyStep.vue?vue&type=template&id=995d640a&"
import script from "./VerifyStep.vue?vue&type=script&lang=js&"
export * from "./VerifyStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports